<template>
    <div class="dialog-screen">
        <el-checkbox v-if="deviceImpDto.showCoverByDevcDef" v-model="deviceImpDto.coverByDevcDef" @change="coverByDevcDefChange">使用定义信息覆盖资产</el-checkbox>
        <div class="table-layout" v-if="showTable">
            <el-table :data="pageDeviceImpInfoList" ref="deviceImpInfoTable" border @selection-change="handleSelectionChange" :row-class-name="markSelectedRowClassName">
                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column label="源件" width="60" align="center" fixed="left">
                    <el-table-column prop="rowNo" label="行号" width="60" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="failed" label="执行状态" width="60" align="center" fixed="left" v-show="startFlag">
                    <template slot-scope="rows">
                        <div v-if="rows.row.failed != null">
                            <span v-if="rows.row.failed" style="color: red;font-size: 20px">×</span>
                            <span v-else style="color: green;font-size: 20px">√</span>
                        </div>
                        <span class="font-gray3" v-else>未执行</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failDesc" label="失败描述" width="500" align="left" fixed="left" v-show="startFlag"></el-table-column>
                <el-table-column v-if="viewFieldFlag('batchNo')" :label="getFieldTitle('batchNo')">
                    <el-table-column prop="batchNo" width="120" :render-header="autoSetBatchNo">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.batchNo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.batchNo"
                                   :title="rows.row.validateInfo.batchNo.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.batchNo"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('devcDefNo')" label="关联定义">
                    <el-table-column prop="devcDefId" width="200" :render-header="setBathDevcDef">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.devcDefId.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.devcDefId.errorMsg">
                                <div class="inline-block" v-if="rows.row.devcDefId != null">已关联</div>
                                <div class="inline-block" v-else>未关联</div>
                                <a class="swb-btn-link fr inline-block" v-if="rows.row.devcDefId == null" @click="setDevcDef(rows.row)">选择</a>
                                <a class="swb-btn-link fr inline-block" v-if="rows.row.devcDefId != null" @click="showDevcDef(rows.row.devcDefId)">查看</a>
                            </div>
                            <div v-else>
                                <div class="inline-block" v-if="rows.row.devcDefId != null">已关联</div>
                                <div class="inline-block" v-else>未关联</div>
                                <a class="swb-btn-link fr inline-block" v-if="rows.row.devcDefId == null" @click="setDevcDef(rows.row)">选择</a>
                                <a class="swb-btn-link fr inline-block" v-if="rows.row.devcDefId != null" @click="showDevcDef(rows.row.devcDefId)">查看</a>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('devcDefNo')" :label="getFieldTitle('devcDefNo')" align="center">
                    <el-table-column prop="devcDefCode" width="140">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.devcDefId.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.devcDefId.errorMsg">
                                <span v-if="rows.row.devcDefCode != null">{{rows.row.devcDefCode}}</span>
                            </div>
                            <div v-else>
                                <span v-if="rows.row.devcDefCode != null">{{rows.row.devcDefCode}}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('innerNo')" :label="getFieldTitle('innerNo')">
                    <el-table-column prop="innerNo" width="150">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.innerNo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.innerNo"
                                   :title="rows.row.validateInfo.innerNo.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.innerNo"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('upc')" :label="getFieldTitle('upc')">
                    <el-table-column prop="upc" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.upc.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.upc" :title="rows.row.validateInfo.upc.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.upc"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('title')" :label="getFieldTitle('title')">
                    <el-table-column prop="title" width="250">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.title.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 240px" v-model="rows.row.title"
                                   :title="rows.row.validateInfo.title.errorMsg"/>
                            <input type="text" v-else style="width:240px" @change="commonChangeEvent" v-model="rows.row.title"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('name')" :label="getFieldTitle('name')">
                    <el-table-column prop="devcName" width="250">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.devcName.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 240px" v-model="rows.row.devcName"
                                   :title="rows.row.validateInfo.devcName.errorMsg"/>
                            <input type="text" v-else style="width:240px" @change="commonChangeEvent" v-model="rows.row.devcName"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('tmpNo')" :label="getFieldTitle('tmpNo')">
                    <el-table-column prop="tmpNo" width="250"></el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('innerCode')" :label="getFieldTitle('innerCode')">
                    <el-table-column prop="innerCode" width="160"></el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('fiscalIgnored')" :label="getFieldTitle('fiscalIgnored')">
                    <el-table-column prop="fiscalIgnored" width="120" align="center">
                        <template slot-scope="rows">
                            <span>{{rows.row.fiscalIgnored ? '是' : '否'}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('retailerBizUnitName')" :label="getFieldTitle('retailerBizUnitName')">
                    <el-table-column prop="bizUnitName" width="250">
                        <template slot-scope="rows">
                            <span>{{rows.row.bizUnitName}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('retailerComName')" :label="getFieldTitle('retailerComName')">
                    <el-table-column prop="shopName" width="250">
                        <template slot-scope="rows">
                            <span>{{rows.row.shopName}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('initStartDate')" :label="getFieldTitle('initStartDate')" align="center">
                    <el-table-column prop="initStartDate" width="90" align="center" :render-header="setInitStartDate">
                        <template slot-scope="rows">
                            <div v-if="rows.row.assetType != '批量式管理' && rows.row.assetType != 1">
                                <div v-if="!rows.row.validateInfo.initStartDate.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.initStartDate.errorMsg">
                                    <span>{{rows.row.initStartDate || ''}}</span>
                                </div>
                                <span v-else>{{rows.row.initStartDate || ''}}</span>
                            </div>
                            <div v-else>
                                <span>{{rows.row.initStartDate}}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('innerDevcCatCode')">
                    <el-table-column prop="innerDevcCatName" width="150" :render-header="setDevcCat">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.innerDevcCatName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.innerDevcCatName.errorMsg">
                                <span>{{rows.row.innerDevcCatName}}&nbsp;</span>
                            </div>
                            <div v-else>{{rows.row.innerDevcCatName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('innerDevcCatCode')" :label="getFieldTitle('innerDevcCatCode')">
                    <el-table-column prop="innerDevcCatCode" width="150">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.innerDevcCatCode.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 190px" v-model="rows.row.innerDevcCatCode"
                                   :title="rows.row.validateInfo.innerDevcCatCode.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.innerDevcCatCode"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('innerDevcBrandCode')" label="资产品牌">
                    <el-table-column prop="innerDevcBrandName" width="150" :render-header="setDevcBrand">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.innerDevcBrandName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.innerDevcBrandName.errorMsg">
                                <span>{{rows.row.innerDevcBrandName}}&nbsp;</span>
                            </div>
                            <div v-else>{{rows.row.innerDevcBrandName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('innerDevcBrandCode')" :label="getFieldTitle('innerDevcBrandCode')">
                    <el-table-column prop="innerDevcBrandCode" width="150">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.innerDevcBrandCode.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.innerDevcBrandCode.errorMsg">
                                <span>{{rows.row.innerDevcBrandCode}}&nbsp;</span>
                            </div>
                            <div v-else>{{rows.row.innerDevcBrandCode}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('brandName')" :label="getFieldTitle('brandName')">
                    <el-table-column prop="brandName" width="150" :render-header="setBrand">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.brandName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.brandName.errorMsg">
                                <span>{{rows.row.brandName}}</span>
                            </div>
                            <span v-else>{{rows.row.brandName}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('devcGroupFullName')" :label="getFieldTitle('devcGroupFullName')">
                    <el-table-column prop="devcGroupFullName" width="150" :render-header="setDevcGroup">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.devcGroupFullName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.devcGroupFullName.errorMsg">
                                <span>{{rows.row.devcGroupFullName}}&nbsp;</span>
                            </div>
                            <div v-else>{{rows.row.devcGroupFullName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('model')" :label="getFieldTitle('model')">
                    <el-table-column prop="model" width="220">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.model.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 190px" v-model="rows.row.model"
                                   :title="rows.row.validateInfo.model.errorMsg"/>
                            <input type="text" v-else style="width:190px" @change="commonChangeEvent" v-model="rows.row.model"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('fixedSpec')" :label="getFieldTitle('fixedSpec')">
                    <el-table-column prop="fixedSpec" width="220">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.fixedSpec.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 190px" v-model="rows.row.fixedSpec"
                                   :title="rows.row.validateInfo.fixedSpec.errorMsg"/>
                            <input type="text" v-else style="width:190px" @change="commonChangeEvent" v-model="rows.row.fixedSpec"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('assetKindCode')" :label="getFieldTitle('assetKindCode')" width="140" align="center">
                    <el-table-column prop="assetKindCode" width="140" align="center">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.assetKindCode.validateOk" @change="commonChangeEvent(rows.row, 'assetKindCode')" style="background-color: #edd28b; width: 190px" v-model="rows.row.assetKindCode"
                                   :title="rows.row.validateInfo.assetKindCode.errorMsg"/>
                            <input type="text" v-else style="width:100px" @change="commonChangeEvent(rows.row, 'assetKindCode')" v-model="rows.row.assetKindCode"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('assetKindName')" :label="getFieldTitle('assetKindName')" width="100">
                    <el-table-column prop="assetKindName" width="140" align="left">
                        <template slot-scope="rows">
                            <span>{{rows.row.assetKindName}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('assetNatureName')" :label="getFieldTitle('assetNatureName')">
                    <el-table-column prop="assetNature" width="120">
                        <template slot-scope="rows">
                            <span>{{ assetNatureMap[rows.row.assetNature] }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('deprSpecCode')" :label="getFieldTitle('deprSpecCode')">
                    <el-table-column prop="deprSpecCode" width="150">
                        <template slot-scope="rows">
                            <div>{{rows.row.deprSpecCode || ''}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('vendorCreditCode')" :label="getFieldTitle('vendorCreditCode')">
                    <el-table-column prop="innerVendorNo" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.innerVendorNo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.innerVendorNo"
                                   :title="rows.row.validateInfo.innerVendorNo.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.innerVendorNo"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('vendorSn')" :label="getFieldTitle('vendorSn')">
                    <el-table-column prop="vendorSn" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.vendorSn.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.vendorSn"
                                   :title="rows.row.validateInfo.vendorSn.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.vendorSn"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('sellerInnerCode')" :label="getFieldTitle('sellerInnerCode')">
                    <el-table-column prop="sellerInnerCode" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.sellerInnerCode.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.sellerInnerCode"
                                   :title="rows.row.validateInfo.sellerInnerCode.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.sellerInnerCode"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('assetTypeTitle')" :label="getFieldTitle('assetTypeTitle')">
                    <el-table-column prop="assetType" width="100">
                        <template slot-scope="rows">
                            <el-select v-model="rows.row.assetType">
                                <el-option v-for="item in assetTypeList" :label="item.text" :value="item.text"/>
                            </el-select>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('inspectFlag')" :label="getFieldTitle('inspectFlag')" align="center">
                    <el-table-column prop="inspectFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.inspectFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('setupFlag')" :label="getFieldTitle('setupFlag')" align="center">
                    <el-table-column prop="setupFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.setupFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('asmblFlag')" :label="getFieldTitle('asmblFlag')" align="center">
                    <el-table-column prop="asmblFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.asmblFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('maintFlag')" :label="getFieldTitle('maintFlag')" align="center">
                    <el-table-column prop="maintFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.maintFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('patrolFlag')" :label="getFieldTitle('patrolFlag')" align="center">
                    <el-table-column prop="patrolFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.patrolFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('repairFlag')" :label="getFieldTitle('repairFlag')" align="center">
                    <el-table-column prop="repairFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.repairFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('splitible')" :label="getFieldTitle('splitible')" align="center">
                    <el-table-column prop="splitible" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.splitible" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('existQuanity')" :label="getFieldTitle('existQuanity')">
                    <el-table-column prop="quantity" width="100" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.quantity.validateOk" @change="commonChangeEvent(rows.row, 'quantity')" type="number" style="background-color: #edd28b; width: 90px" size="6"
                                   v-model="rows.row.quantity" :min="0" :max="100000" :title="rows.row.validateInfo.quantity.errorMsg"/>
                            <input class="align-right" v-else type="number" size="6" @change="commonChangeEvent(rows.row, 'quantity')" v-model="rows.row.quantity" :min="0" :max="100000" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('theUnit')" :label="getFieldTitle('theUnit')">
                    <el-table-column prop="theUnit" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.theUnit.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.theUnit"
                                   :title="rows.row.validateInfo.theUnit.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.theUnit"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('receiveTime')" :label="getFieldTitle('receiveTime')" align="center">
                    <el-table-column prop="recvDate" width="90" align="center" :render-header="setRecvDate">
                        <template slot-scope="rows">
                            <span>{{rows.row.recvDate}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('wrntPeriod')" :label="getFieldTitle('wrntPeriod')" align="center">
                    <el-table-column prop="wrntPeriod" width="100" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.wrntPeriod.validateOk" @change="commonChangeEvent" type="number" style="background-color: #edd28b; width: 90px" size="4" v-model="rows.row.wrntPeriod"
                                   :min="0" :max="100000" :title="rows.row.validateInfo.wrntPeriod.errorMsg"/>
                            <input class="align-right" v-else type="number" size="4" @change="commonChangeEvent" v-model="rows.row.wrntPeriod" :min="0" :max="100000" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('useMannerText')" :label="getFieldTitle('useMannerText')" width="140" align="center">
                    <el-table-column prop="useMannerText" width="140" align="center">
                        <template slot-scope="rows">
                            <el-select v-model="rows.row.useMannerText" @change="commonChangeEvent">
                                <el-option v-for="item in devcUseMannerList" :key="item.text" :label="item.text" :value="item.text"/>
                            </el-select>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('acctEnterWayText')" :label="getFieldTitle('acctEnterWayText')" align="center">
                    <el-table-column prop="acctEnterWay" width="100" align="center">
                        <template slot-scope="rows">
                            <el-select v-model="rows.row.acctEnterWayText">
                                <el-option v-for="item in acctEnterWayList" :label="item.text" :value="item.text"/>
                            </el-select>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('allotAcntMethod')" :label="getFieldTitle('allotAcntMethod')" width="140" align="center">
                    <el-table-column prop="allotAcntMethod" width="140" align="center">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.allotAcntMethod.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.allotAcntMethod.errorMsg">
                                <el-select v-model="rows.row.allotAcntMethod" @change="commonChangeEvent" class="select-warn">
                                    <el-option v-for="item in allotAcntMethodList" :key="item.label" :label="item.label" :value="item.label"/>
                                </el-select>
                            </div>
                            <div v-else>
                                <el-select v-model="rows.row.allotAcntMethod" @change="commonChangeEvent">
                                    <el-option v-for="item in allotAcntMethodList" :key="item.label" :label="item.label" :value="item.label"/>
                                </el-select>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('transWorthRatio')" :label="getFieldTitle('transWorthRatio')" align="center">
                    <el-table-column prop="transWorthRatio" width="100" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.transWorthRatio.validateOk" @change="commonChangeEvent" type="number" size="4" v-model="rows.row.transWorthRatio"
                                   style="background-color: #edd28b; width: 90px" :title="rows.row.validateInfo.transWorthRatio.errorMsg"/>
                            <input class="align-right" v-else type="number" size="4" @change="commonChangeEvent" v-model="rows.row.transWorthRatio" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('orgWorth')" :label="getFieldTitle('orgWorth')" align="center">
                    <el-table-column prop="orgWorth" width="100" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.orgWorth.validateOk" @change="commonChangeEvent" type="number" size="4" v-model="rows.row.orgWorth" style="background-color: #edd28b; width: 90px"
                                   :title="rows.row.validateInfo.orgWorth.errorMsg"/>
                            <input class="align-right" v-else type="number" size="4" @change="commonChangeEvent" v-model="rows.row.orgWorth" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('rmnWorthRatio')" :label="getFieldTitle('rmnWorthRatio')" align="center">
                    <el-table-column prop="rmnWorthRatio" width="100" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.rmnWorthRatio.validateOk" @change="commonChangeEvent" type="number" size="4" v-model="rows.row.rmnWorthRatio" style="background-color: #edd28b; width: 90px"
                                   :title="rows.row.validateInfo.rmnWorthRatio.errorMsg"/>
                            <input class="align-right" v-else type="number" size="4" @change="commonChangeEvent" v-model="rows.row.rmnWorthRatio" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('durableLife')" :label="getFieldTitle('durableLife')" align="center">
                    <el-table-column prop="expectedLife" width="100" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.expectedLife.validateOk" @change="commonChangeEvent" type="number" size="4" v-model="rows.row.expectedLife" style="background-color: #edd28b; width: 90px"
                                   :title="rows.row.validateInfo.expectedLife.errorMsg"/>
                            <input class="align-right" v-else type="number" size="4" @change="commonChangeEvent" v-model="rows.row.expectedLife" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('deprMethodName')" :label="getFieldTitle('deprMethodName')" width="140" align="center">
                    <el-table-column prop="deprMethodName" width="140" align="center">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.deprMethodName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.deprMethodName.errorMsg">
                                <el-select v-model="rows.row.deprMethodName" @change="commonChangeEvent" class="select-warn">
                                    <el-option v-for="item in assetDeprMethodList" :key="item.label" :label="item.label" :value="item.label"/>
                                </el-select>
                            </div>
                            <div v-else>
                                <el-select v-model="rows.row.deprMethodName" @change="commonChangeEvent">
                                    <el-option v-for="item in assetDeprMethodList" :key="item.label" :label="item.label" :value="item.label"/>
                                </el-select>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('cnt1stMonth')" :label="getFieldTitle('cnt1stMonth')" align="center">
                    <el-table-column prop="deprOn1stMonth" width="100" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.deprOn1stMonth" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('fiscalInTime')" :label="getFieldTitle('fiscalInTime')" align="center">
                    <el-table-column prop="fiscalInTime" width="90" align="center" :render-header="setfiscalInTime">
                        <template slot-scope="rows">
                            <span v-if="rows.row.fiscalInTime != null">{{rows.row.fiscalInTime}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('buyDate')" :label="getFieldTitle('buyDate')" align="center">
                    <el-table-column prop="buyDate" width="90" align="center" :render-header="setBuyDate">
                        <template slot-scope="rows">
                            <span v-if="rows.row.buyDate != null">{{rows.row.buyDate}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('onsetDate')" :label="getFieldTitle('onsetDate')" align="center">
                    <el-table-column prop="onsetDate" width="90" align="center" :render-header="setOnsetDate">
                        <template slot-scope="rows">
                            <span v-if="rows.row.onsetDate != null">{{rows.row.onsetDate}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('aggtDeprWorth')" :label="getFieldTitle('aggtDeprWorth')" align="center">
                    <el-table-column prop="aggtDeprWorth" width="90" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.aggtDeprWorth.validateOk" @change="commonChangeEvent" type="number" size="4" v-model="rows.row.aggtDeprWorth" style="background-color: #edd28b; width: 90px"
                                   :title="rows.row.validateInfo.aggtDeprWorth.errorMsg"/>
                            <input class="align-right" v-else type="number" size="4" @change="commonChangeEvent" v-model="rows.row.aggtDeprWorth" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('lastDeprMonth')" :label="getFieldTitle('lastDeprMonth')" align="center">
                    <el-table-column prop="lastDeprMonth" width="90" align="center" :render-header="setLastDeprMonth">
                        <template slot-scope="rows">
                            <span v-if="rows.row.lastDeprMonth != null">{{rows.row.lastDeprMonth}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('fiscalAbnormal')" :label="getFieldTitle('fiscalAbnormal')" align="center">
                    <el-table-column prop="fiscalAbnormal" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.fiscalAbnormal" @change="commonChangeEvent(rows.row)"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('respblDepartName')" :label="getFieldTitle('respblDepartName')">
                    <el-table-column prop="departName" width="120" :render-header="setDepart">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.departName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.departName.errorMsg">
                                <span>{{rows.row.departName}}</span>
                            </div>
                            <div v-else>{{rows.row.departName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('respblStaffName')" :label="getFieldTitle('respblStaffName')">
                    <el-table-column prop="principalName" width="200" :render-header="setBathPrincipal">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.principalName.validateOk" class="inline-block" style="background-color: #edd28b; width: 50%;height: 100%" :title="rows.row.validateInfo.principalName.errorMsg">
                                <span>{{rows.row.principalName}}</span>
                            </div>
                            <div class="inline-block" v-else>{{rows.row.principalName}}</div>
                            <a class="swb-btn-link fr inline-block" @click="delPrincipal(rows.row)">清除</a>
                            <a class="swb-btn-link fr inline-block" @click="setPrincipal(rows.row)">设置</a>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('principalNo')" :label="getFieldTitle('principalNo')">
                    <el-table-column prop="principalNo" width="200">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.principalName.validateOk" class="inline-block" style="background-color: #edd28b; width: 50%;height: 100%" :title="rows.row.validateInfo.principalName.errorMsg">
                                <span>{{rows.row.principalNo}}</span>
                            </div>
                            <div class="inline-block" v-else>{{rows.row.principalNo}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('memo')" :label="getFieldTitle('memo')">
                    <el-table-column prop="memo" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.memo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.memo" :title="rows.row.validateInfo.memo.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.memo"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('memo1')" :label="getFieldTitle('memo1')">
                    <el-table-column prop="memo1" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.memo1.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.memo1"
                                   :title="rows.row.validateInfo.memo1.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.memo1"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('memo2')" :label="getFieldTitle('memo2')">
                    <el-table-column prop="memo2" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.memo2.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.memo2"
                                   :title="rows.row.validateInfo.memo2.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.memo2"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('memo3')" :label="getFieldTitle('memo3')">
                    <el-table-column prop="memo3" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.memo3.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.memo3"
                                   :title="rows.row.validateInfo.memo3.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.memo3"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('classifyTagName')" :label="getFieldTitle('classifyTagName')">
                    <el-table-column prop="classifyTagName" width="120" :render-header="setClassifyTag">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.classifyTagName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.classifyTagName.errorMsg">
                                <span>{{rows.row.classifyTagName}}&nbsp;</span>
                            </div>
                            <div v-else>{{rows.row.classifyTagName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('grabIssueAllowed')" :label="getFieldTitle('grabIssueAllowed')" align="center">
                    <el-table-column prop="grabIssueAllowed" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.grabIssueAllowed" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <template v-for="field in devcCustFieldList">
                    <el-table-column v-if="viewFieldFlag('ext-' + field.name, true)" :label="'自定义-' + field.title">
                        <el-table-column width="120" v-if="field.type == 'Date'" :render-header="((event)=>{return setCustField(event, 'ext-' + field.name)})">
                            <template slot-scope="rows">
                                <span v-if="rows.row.custFiled['ext-' + field.name] != null">{{ rows.row.custFiled['ext-' + field.name] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column width="120" v-else>
                            <template slot-scope="rows">
                                <div v-if=" rows.row.classifyTagId != null && classifyTagMap[rows.row.classifyTagId] != null && classifyTagMap[rows.row.classifyTagId].fieldIds.indexOf(field.id) > -1">
                                    <div v-if="field.type == 'String'">
                                        <input type="text" style="width:110px" @change="commonChangeEvent" v-model="rows.row.custFiled['ext-' + field.name]"/>
                                    </div>
                                    <div v-else-if="field.type == 'Integer' || field.type == 'Long' || field.type == 'Float' || field.type == 'Double'">
                                        <input class="align-right" type="number" size="4" @change="commonChangeEvent" v-model="rows.row.custFiled['ext-' + field.name]" style="width: 90px"/>
                                    </div>
                                    <div v-else-if="field.type == 'Boolean'">
                                        <input type="checkbox" v-model="rows.row.custFiled['ext-' + field.name]" @change="commonChangeEvent"/>
                                    </div>
                                </div>
                                <div v-else>
                                    <input type="text" style="width:110px" :disabled="true"/>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="clearfix">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="doDeviceImpModelImport">导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="validateDeviceImpModel(true)">逐条检查</div>
        </div>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {openPageRouteUrl, getDefaultPageSizes} from '../../../src/app.conf'
    import {showMerchtDevcDefSelectDlg, openDevcDefDetailDlg} from '../devcDef/showDlg'
    import {openBrandListSelectDlg, showDevcCatSelectDlg, showDevcGroupCatSelectDlg, showDevcBrandSelectDlg, showDevcGroupSelectDlg} from '../categ/selectDlg'
    import {openComStaffComnSelectDlg} from '../orgStruct/selectDlg'
    import {getMerchantBizParam} from '../asset/assetMain'
    import {loadAssetDeprMethodList, loadAllotAcntMethodList} from '../retailer/asset-comn'
    import {showDevcClassifyTagListSelectDlg} from '../devcCust/selectDlg'

    import devcApi from '../../api/devc'
    import retailerApi from '../../api/retailer'
    import shopStockApi from '../../api/shopStock'
    import userApi from '../../api/user'
    import merchtComnApi from '../../api/merchtComn'
    import comnApi from '../../api/comn'

    import SwbCategTree from '../categ/CategTree';
    Vue.regist(SwbCategTree);
    import SwbDefServicerForSelect from '../servicer/DefServicerForSelect';
    Vue.regist(SwbDefServicerForSelect);
    import SwbBrandSelect from '../categ/BrandSelect';
    Vue.regist(SwbBrandSelect);
    import SwbShopDeviceImpSetDate from './ShopDeviceImpSetDate';
    Vue.regist(SwbShopDeviceImpSetDate);

    export default {
        name: 'swb-shop-device-fiscal-in-imp-devc-check',
        desc: '机构设备导入检查',
        props: ['fileObj', 'rootWidth', 'rootHeight', 'theDlg'],
        data: function () {
            return {
                tableHeight: 0,
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: [15, 50, 100, 200],// 特殊页面处理
                pageDeviceImpInfoList: {},
                deviceImpDto: {
                    retailerShopId: null,
                    originalFileName: null,
                    deviceImpInfoList: [],
                    dumyBrandNames: [],
                    warehouseId: null,
                    warehouseName: null,
                    srcVoucherType: null,
                    srcVoucherNo: null,
                    importRecId: null,
                    ioVoucherId: null,
                    showCoverByDevcDef: false,
                    coverByDevcDef: false
                },
                isOk: false,
                theLoading: null,
                multipleSelection: [],
                virtualBrandStr: '',
                max_quantity_per_item: 500,
                acctEnterWayList: getEnumList('acctEnterWay'),
                deviceUseStateList: getEnumList('deviceUseState'),
                devcVoucherTypeList: getEnumList('devcVoucherType'),
                devcUseMannerList: getEnumList("devcUseManner"),
                devcUseMannerMap: getEnumMap("devcUseManner", "value2text"),
                warehouseList: [],
                startFlag: false, // 标记是否已开始逐条执行
                nextIndex: 0,
                checkNextIndex: 0,
                scopeId: null,
                assetDeprMethodList: [],
                uknoPrefix: null,
                assetNatureMap: getEnumMap("assetNature", "value2text"),
                assetTypeMap: getEnumMap("assetType", "value2text"),
                allotAcntMethodMap: getEnumMap("allotAcntMethod", "value2text"),
                allotAcntMethodList: [],
                devcCustFieldList: [],
                classifyTagMap: {},
                comnXportConf: {},
                fieldMap: {},
                custFileds: [],
                showTable: false,
                assetTypeList: [],
            }
        },
        watch: {
            rootWidth(newVal, oldVal){
                //
            },
            rootHeight(newVal, oldVal){
                this.recalcTableHeight();
            }
        },
        created: function () {
            let self = this;
            this.recalcTableHeight();
            this.getDevcCustFieldList();
            this.getDevcClassifyTagPageList();
            this.getComnXportConfByUsage(this.fileObj.extra.tplUsage, function () {
                self.getMerchtImpTplDlInfo(self.fileObj.extra.tplUsage, function () {
                    self.showTable = true;
                });
            });
            // 管理方式
            let assetTypeEnumList = getEnumList('assetType') || [];
            let assetTypeList = [];
            for (let i = 0; i < assetTypeEnumList.length; i++) {
                let assetTypeEnum = assetTypeEnumList[i];
                if (assetTypeEnum.name == 'CommonDevc' || assetTypeEnum.name == 'DurableDevc') {
                    assetTypeList.push(assetTypeEnum);
                }
            }
            this.assetTypeList = Utils.merge([], assetTypeList);
            // 折旧算法
            loadAssetDeprMethodList(0, function (dataList) {
                self.assetDeprMethodList = Utils.merge([], dataList);
            });
            loadAllotAcntMethodList(function (dataList) {
                self.allotAcntMethodList = Utils.merge([], dataList);
            });
            //
            let theLoading = MsgBox.loading();
            this.deviceImpDto.retailerShopId = this.fileObj.extra.retailerShopId;
            this.deviceImpDto.retailerBizUnitId = this.fileObj.extra.retailerBizUnitId;
            this.deviceImpDto.originalFileName = this.fileObj.extra.originalFileName;
            this.deviceImpDto.deviceFlag = this.fileObj.extra.deviceFlag;
            this.deviceImpDto.durable = this.fileObj.extra.durable;
            this.deviceImpDto.tplUsage = this.fileObj.extra.tplUsage;
            this.deviceImpDto.showCoverByDevcDef = this.fileObj.extra.showCoverByDevcDef;
            this.deviceImpDto.coverByDevcDef = this.fileObj.extra.coverByDevcDef;
            let deviceImpInfoList = this.fileObj.extra.deviceImpInfoList;
            deviceImpInfoList.forEach(function (el) {
                el.validateInfo = {
                    devcDefId: {validateOk: true},
                    devcDefCode: {validateOk: true},
                    batchNo: {validateOk: true},
                    innerCode: {validateOk: true},
                    innerNo: {validateOk: true},
                    upc: {validateOk: true},
                    devcName: {validateOk: true},
                    title: {validateOk: true},
                    shopName: {validateOk: true},
                    bizUnitName: {validateOk: true},
                    initStartDate: {validateOk: true},
                    innerDevcCatName: {validateOk: true},
                    innerDevcCatCode: {validateOk: true},
                    innerDevcBrandName: {validateOk: true},
                    innerDevcBrandCode: {validateOk: true},
                    brandName: {validateOk: true},
                    devcGroupFullName: {validateOk: true},
                    assetKindCode: {validateOk: true},
                    deprSpecCode: {validateOk: true},
                    model: {validateOk: true},
                    fixedSpec: {validateOk: true},
                    innerVendorNo: {validateOk: true},
                    vendorSn: {validateOk: true},
                    sellerInnerCode: {validateOk: true},
                    quantity: {validateOk: true},
                    theUnit: {validateOk: true},
                    buyDate: {validateOk: true},
                    recvDate: {validateOk: true},
                    wrntPeriod: {validateOk: true},
                    departName: {validateOk: true},
                    principalName: {validateOk: true},
                    allotAcntMethod: {validateOk: true},
                    transWorthRatio: {validateOk: true},
                    orgWorth: {validateOk: true},
                    rmnWorthRatio: {validateOk: true},
                    expectedLife: {validateOk: true},
                    deprMethodName: {validateOk: true},
                    aggtDeprWorth: {validateOk: true},
                    memo: {validateOk: true},
                    memo1: {validateOk: true},
                    memo2: {validateOk: true},
                    memo3: {validateOk: true},
                    classifyTagName: {validateOk: true}
                };
            });
            this.deviceImpDto.deviceImpInfoList = deviceImpInfoList;

            this.pageSize = this.pageSizes.first();
            self.checkData();
            self.setPageDeviceImpInfoList();
            self.getWarehouseList();
            this.getCurrUserInfo();
            theLoading.close();
        },
        methods: {
            viewFieldFlag(name, ignoreBase){
                let custFileds = this.custFileds;
                let custFlag = true;
                if (!Utils.isNoB(custFileds) && custFileds.length > 0) {
                    custFlag = this.custFileds.indexOf(name) > -1;
                }
                //
                let baseFlag = this.fieldMap[name] != null;
                if (Utils.isTrue(ignoreBase)) {
                    baseFlag = true;
                }
                return custFlag && baseFlag;
            },
            getFieldTitle(name, defTitle){
                return this.fieldMap[name] != null ? this.fieldMap[name].title : defTitle;
            },
            getMerchtImpTplDlInfo(tplUsage, callback){
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getMerchtImpTplDlInfo({tplUsage: tplUsage}, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let merchtImpTplDlInfo = result.data;
                        if (!Utils.isNoB(merchtImpTplDlInfo) && !Utils.isNoB(merchtImpTplDlInfo.tplConfig)) {
                            let custFiledMap = JSON.decode(merchtImpTplDlInfo.tplConfig);
                            self.custFileds = custFiledMap['店铺资产列表'];
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                    callback();
                });
            },
            getComnXportConfByUsage(tplUsage, callback){
                let self = this;
                let theLoading = MsgBox.loading();
                comnApi.getComnXportConfByUsage({usage: tplUsage}, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let comnXportConf = result.data;
                        //
                        let sheetList = comnXportConf.sheetList;
                        sheetList.forEach(function (sheet) {
                            if (sheet.name == '店铺资产列表') {
                                let fieldList = sheet.fieldList;
                                self.fieldMap = fieldList.toMap('name');
                            }
                        });
                        //
                        self.comnXportConf = comnXportConf;
                    } else {
                        MsgBox.warning(result.message);
                    }
                    callback();
                });
            },
            getDevcCustFieldList(){
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcCustFieldList({}, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let devcCustFieldList = result.data;
                        self.devcCustFieldList = Utils.merge([], devcCustFieldList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDevcClassifyTagPageList(){
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcClassifyTagPageList({
                    filterItems: {
                        includeFields: true
                    },
                    pagination: {
                        pageSize: 999999
                    }
                }, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let classifyTagList = result.data.rows || [];
                        classifyTagList.forEach(function (tag) {
                            tag.fieldIds = tag.devcClassifyTagSpecFields.pluck('custFieldId');
                        });
                        self.classifyTagMap = classifyTagList.toMap('id');
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getCurrUserInfo() {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if (result.type == 'info') {
                        self.scopeId = result.data.scopeEntity.scopeId;
                        self.getRetailer(result.data.scopeEntity.id);
                    }
                });
            },
            getRetailer: function (merchantId) {
                let self = this;
                retailerApi.getRetailer({retailerId: merchantId}, function (result) {
                    if (result.type == 'info') {
                        self.uknoPrefix = result.data.uknoPrefix;
                    }
                });
            },
            getWarehouseList(){
                let self = this;
                let postData = {};
                let retailerShopId = self.deviceImpDto.retailerShopId;
                if (!Utils.isNoB(retailerShopId)) {
                    postData.filterItems = {
                        retailerShopId: retailerShopId
                    }
                }
                let msgBoxDlg = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        self.warehouseList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            recalcTableHeight(){
                this.tableHeight = this.rootHeight - 60 - 42;
            },
            markSelectedRowClassName(row){
                return this.multipleSelection.find(function (tmpRow) {
                    return tmpRow.rowNo == row.rowNo;
                }) != null ? 'selected-row' : '';
            },
            //自动合并数据行
            autoMergeItems(){
                let deviceImpInfoList = this.deviceImpDto.deviceImpInfoList.clone();
                //汇总
                let tmpList = deviceImpInfoList.split(function (item) {
                    let values = [];
                    values.add(item.devcDefId == null ? "" : item.devcDefId);
                    values.add(item.batchNo == null ? "" : item.batchNo.trim());
                    values.add(item.innerCode == null ? "" : item.innerCode.trim());
                    values.add(item.upc == null ? "" : item.upc.trim());
                    values.add(item.devcName == null ? "" : item.devcName.trim());
                    values.add(item.title == null ? "" : item.title.trim());
                    values.add(item.innerDevcCatName == null ? "" : item.innerDevcCatName.trim());
                    values.add(item.innerDevcCatCode == null ? "" : item.innerDevcCatCode.trim());
                    values.add(item.innerDevcBrandName == null ? "" : item.innerDevcBrandName.trim());
                    values.add(item.innerDevcBrandCode == null ? "" : item.innerDevcBrandCode.trim());
                    values.add(item.innerDevcCatName == null ? "" : item.innerDevcCatName.trim());
                    values.add(item.innerDevcCatCode == null ? "" : item.innerDevcCatCode.trim());
                    values.add(item.innerDevcBrandName == null ? "" : item.innerDevcBrandName.trim());
                    values.add(item.innerDevcBrandCode == null ? "" : item.innerDevcBrandCode.trim());
                    values.add(item.catName == null ? "" : item.catName.trim());
                    values.add(item.brandName == null ? "" : item.brandName.trim());
                    values.add(item.model == null ? "" : item.model.trim());
                    values.add(item.fixedSpec == null ? "" : item.fixedSpec.trim());
                    values.add(item.buyDate == null ? "" : item.buyDate.trim());
                    values.add(item.recvDate == null ? "" : item.recvDate.trim());
                    values.add(item.wrntPeriod == null ? "" : item.wrntPeriod);
                    values.add(item.acctEnterWay == null ? "" : item.acctEnterWay);
                    values.add(item.useState == null ? "" : item.useState);
                    values.add(item.departName == null ? "" : item.departName.trim());
                    values.add(item.principalName == null ? "" : item.principalName.trim());
                    values.add(item.theUnit == null ? "" : item.theUnit.trim());
                    values.add(item.durable == null ? "" : item.durable);
                    values.add(item.vendorSn == null ? "" : item.vendorSn.trim());
                    values.add(item.sellerInnerCode == null ? "" : item.sellerInnerCode.trim());
                    return values.join("::");
                });
                deviceImpInfoList = [];
                tmpList.forEach(function (sameItems) {
                    let first = Utils.merge({}, sameItems.first());
                    first.quantity = sameItems.sum(function (el) {
                        if (typeof el == 'undefined') {
                            //返回初始值
                            return 0;
                        }
                        else {
                            return el.quantity == null ? 0 : el.quantity;
                        }
                    });
                    //
                    deviceImpInfoList.add(first);
                });
                //排序（分类、品牌、购买日期、收货日期、店铺）
                deviceImpInfoList = sortArray(deviceImpInfoList, function (e1, e2) {
                    let tmpVal1 = "";
                    let tmpVal2 = "";
                    //
                    tmpVal1 = e1.innerDevcCatName || "";
                    tmpVal2 = e2.innerDevcCatName || "";
                    if (tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    tmpVal1 = e1.innerDevcBrandName || "";
                    tmpVal2 = e2.innerDevcBrandName || "";
                    if (tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    tmpVal1 = e1.catName || "";
                    tmpVal2 = e2.catName || "";
                    if (tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    tmpVal1 = e1.brandName || "";
                    tmpVal2 = e2.brandName || "";
                    if (tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    tmpVal1 = e1.buyDate || "";
                    tmpVal2 = e2.buyDate || "";
                    if (tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    tmpVal1 = e1.recvDate || "";
                    tmpVal2 = e2.recvDate || "";
                    if (tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    tmpVal1 = e1.shopName || "";
                    tmpVal2 = e2.shopName || "";
                    if (tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    tmpVal1 = e1.bizUnitName || "";
                    tmpVal2 = e2.bizUnitName || "";
                    if (tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    return 0;
                });
                //console.log(deviceImpInfoList);
                this.deviceImpDto.deviceImpInfoList = deviceImpInfoList;
                this.checkData();
            },
            commonChangeEvent(row, colName){
                if (!Utils.isNoB(colName) && colName == 'durable') {
                    this.delDevcDef(row);
                } else {
                    this.checkData();
                }
            },
            quantityChangeEvent(value){
                this.checkData();
            },
            checkData () {
                let self = this;
                let rows = this.deviceImpDto.deviceImpInfoList.clone();
                let itemLength = rows.length;
                let byItemFlag = itemLength > 500;
                for (let i = 0; i < rows.length; i++) {
                    let deviceImpDto = rows[i];
                    deviceImpDto.validateInfo = {
                        devcDefId: {validateOk: true},
                        devcDefCode: {validateOk: true},
                        batchNo: {validateOk: true},
                        innerCode: {validateOk: true},
                        innerNo: {validateOk: true},
                        upc: {validateOk: true},
                        devcName: {validateOk: true},
                        title: {validateOk: true},
                        shopName: {validateOk: true},
                        bizUnitName: {validateOk: true},
                        initStartDate: {validateOk: true},
                        innerDevcCatName: {validateOk: true},
                        innerDevcCatCode: {validateOk: true},
                        innerDevcBrandName: {validateOk: true},
                        innerDevcBrandCode: {validateOk: true},
                        brandName: {validateOk: true},
                        devcGroupFullName: {validateOk: true},
                        assetKindCode: {validateOk: true},
                        deprSpecCode: {validateOk: true},
                        model: {validateOk: true},
                        fixedSpec: {validateOk: true},
                        innerVendorNo: {validateOk: true},
                        vendorSn: {validateOk: true},
                        sellerInnerCode: {validateOk: true},
                        quantity: {validateOk: true},
                        theUnit: {validateOk: true},
                        buyDate: {validateOk: true},
                        recvDate: {validateOk: true},
                        wrntPeriod: {validateOk: true},
                        departName: {validateOk: true},
                        principalName: {validateOk: true},
                        allotAcntMethod: {validateOk: true},
                        transWorthRatio: {validateOk: true},
                        orgWorth: {validateOk: true},
                        rmnWorthRatio: {validateOk: true},
                        expectedLife: {validateOk: true},
                        deprMethodName: {validateOk: true},
                        aggtDeprWorth: {validateOk: true},
                        memo: {validateOk: true},
                        memo1: {validateOk: true},
                        memo2: {validateOk: true},
                        memo3: {validateOk: true},
                        classifyTagName: {validateOk: true}
                    };
                    if (Utils.isNoB(deviceImpDto.devcDefId)) {
                        deviceImpDto.validateInfo.devcDefId = {
                            validateOk: false,
                            errorMsg: "[关联定义]单元不能为空"
                        };
                    }
                    // 检查修正 [批次号]
                    if (!Utils.isNoB(deviceImpDto.batchNo)) {
                        deviceImpDto.batchNo = this.replaceSL(deviceImpDto.batchNo, '');
                        if (deviceImpDto.batchNo.length > 20) {
                            deviceImpDto.validateInfo.batchNo = {
                                validateOk: false,
                                errorMsg: "[批次号]单元长度最大20，当前[" + deviceImpDto.batchNo.length + "]"
                            };
                        }
                    } else {
                        deviceImpDto.validateInfo.batchNo = {
                            validateOk: false,
                            errorMsg: "[批次号]单元不能为空"
                        };
                    }
                    // 检查修正 [内部编码]
                    if (!Utils.isNoB(deviceImpDto.innerNo)) {
                        deviceImpDto.innerNo = this.replaceSL(deviceImpDto.innerNo, '');
                        if (deviceImpDto.innerNo.length > 30) {
                            deviceImpDto.validateInfo.upc = {
                                validateOk: false,
                                errorMsg: "[外部系统编号]单元长度最大30，当前[" + deviceImpDto.innerNo.length + "]"
                            };
                        }
                    }
                    // 检查修正 [统一商品代码(UPC)]
                    if (!Utils.isNoB(deviceImpDto.upc)) {
                        deviceImpDto.upc = this.replaceSL(deviceImpDto.upc, '');
                        if (deviceImpDto.upc.length > 30) {
                            deviceImpDto.validateInfo.upc = {
                                validateOk: false,
                                errorMsg: "[统一商品代码(UPC)]单元长度最大30，当前[" + deviceImpDto.upc.length + "]"
                            };
                        }
                    }
                    // 检查 [设备名称]
                    if (!Utils.isNoB(deviceImpDto.devcName)) {
                        deviceImpDto.devcName = this.replaceSL(deviceImpDto.devcName, ' ');
                    }
                    if (Utils.isNoB(deviceImpDto.devcName)) {
                        deviceImpDto.validateInfo.devcName = {
                            validateOk: false,
                            errorMsg: "[名称]单元不可为空"
                        };
                    } else if (deviceImpDto.devcName.length > 30) {
                        deviceImpDto.validateInfo.devcName = {
                            validateOk: false,
                            errorMsg: "[名称]单元长度最大30，当前[" + deviceImpDto.devcName.length + "]"
                        };
                    }
                    // 检查[设备描述全称]
                    if (!Utils.isNoB(deviceImpDto.title)) {
                        deviceImpDto.title = this.replaceSL(deviceImpDto.title, ' ');
                    }
                    if (Utils.isNoB(deviceImpDto.title)) {
                        deviceImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[设备描述全称]单元不可为空"
                        };
                    } else if (deviceImpDto.title.length > 60) {
                        deviceImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[设备描述全称]单元长度最大60，当前[" + deviceImpDto.title.length + "]"
                        };
                    }
                    // 资产分类
                    if (Utils.isNoB(deviceImpDto.innerDevcCatId)) {
                        if (!Utils.isNoB(deviceImpDto.innerDevcCatName)) {
                            deviceImpDto.validateInfo.innerDevcCatName = {
                                validateOk: false,
                                errorMsg: "[资产分类]不存在,请预设资产分类"
                            };
                        } else {
                            deviceImpDto.validateInfo.innerDevcCatName = {
                                validateOk: false,
                                errorMsg: "[资产分类]不可为空"
                            };
                        }
                        if (!Utils.isNoB(deviceImpDto.innerDevcCatCode)) {
                            deviceImpDto.validateInfo.innerDevcCatCode = {
                                validateOk: false,
                                errorMsg: "[资产分类编码]不存在,请预设资产分类"
                            };
                        } else {
                            deviceImpDto.validateInfo.innerDevcCatCode = {
                                validateOk: false,
                                errorMsg: "[资产分类编码]不可为空"
                            };
                        }
                    }
                    // 资产品牌
                    if (Utils.isNoB(deviceImpDto.innerDevcBrandId)) {
                        if (!Utils.isNoB(deviceImpDto.innerDevcBrandName)) {
                            deviceImpDto.validateInfo.innerDevcBrandName = {
                                validateOk: false,
                                errorMsg: "[资产品牌]不存在,请预设资产品牌"
                            };
                        } else {
                            deviceImpDto.validateInfo.innerDevcBrandName = {
                                validateOk: false,
                                errorMsg: "[资产品牌]不可为空"
                            };
                        }
                        if (!Utils.isNoB(deviceImpDto.innerDevcBrandCode)) {
                            deviceImpDto.validateInfo.innerDevcBrandCode = {
                                validateOk: false,
                                errorMsg: "[资产品牌编码]不存在,请预设资产品牌"
                            };
                        } else {
                            deviceImpDto.validateInfo.innerDevcBrandCode = {
                                validateOk: false,
                                errorMsg: "[资产品牌编码]不可为空"
                            };
                        }
                    }
                    // 检查 [型号]
                    if (!Utils.isNoB(deviceImpDto.model)) {
                        deviceImpDto.model = this.replaceSL(deviceImpDto.model, ' ');
                    }
                    if (Utils.isNoB(deviceImpDto.model)) {
                        //
                    } else if (deviceImpDto.model.length > 30) {
                        deviceImpDto.validateInfo.model = {
                            validateOk: false,
                            errorMsg: "[型号]单元长度最大30，当前[" + deviceImpDto.model.length + "]"
                        };
                    }
                    // 检查 [规格]
                    if (!Utils.isNoB(deviceImpDto.fixedSpec)) {
                        deviceImpDto.fixedSpec = this.replaceSL(deviceImpDto.fixedSpec, ' ');
                    }
                    if (Utils.isNoB(deviceImpDto.fixedSpec) && deviceImpDto.fixedSpec != '') {
                        deviceImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[规格]单元不能为空"
                        };
                    } else if (deviceImpDto.fixedSpec.length > 45) {
                        deviceImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[规格]单元长度最大45，当前[" + deviceImpDto.fixedSpec.length + "]"
                        };
                    }
                    //
                    let modelSpec = deviceImpDto.model + deviceImpDto.fixedSpec;
                    if (Utils.isNoB(modelSpec) || modelSpec.length > 75) {
                        deviceImpDto.validateInfo.model = {
                            validateOk: false,
                            errorMsg: "[型号 + 规格]单元长度最大75，当前[" + deviceImpDto.model.length + "]"
                        };
                        deviceImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[型号 + 规格]单元长度最大75，当前[" + deviceImpDto.fixedSpec.length + "]"
                        };
                    }
                    // 检查修正 [供商统一社会信用码]
                    if (!Utils.isNoB(deviceImpDto.innerVendorNo)) {
                        deviceImpDto.innerVendorNo = this.replaceSL(deviceImpDto.innerVendorNo, '');
                        if (deviceImpDto.innerVendorNo.length != 18) {
                            deviceImpDto.validateInfo.innerVendorNo = {
                                validateOk: false,
                                errorMsg: "[供商统一社会信用码]单元长度必须为18，当前[" + deviceImpDto.innerVendorNo.length + "]"
                            };
                        }
                    }
                    // 检查修正 [厂商序列号]
                    if (deviceImpDto.assetType == '单品式管理' || deviceImpDto.assetType == 0) {
                        if (!Utils.isNoB(deviceImpDto.vendorSn)) {
                            deviceImpDto.vendorSn = this.replaceSL(deviceImpDto.vendorSn, '');
                            if (!Utils.isNaturalStr(deviceImpDto.quantity, true) || deviceImpDto.quantity != 1) {
                                deviceImpDto.validateInfo.vendorSn = {
                                    validateOk: false,
                                    errorMsg: "[厂商序列号]单元有效时数量必须为1"
                                };
                            } else {
                                if (deviceImpDto.vendorSn.length > 30) {
                                    deviceImpDto.validateInfo.vendorSn = {
                                        validateOk: false,
                                        errorMsg: "[厂商序列号]单元长度最大30，当前[" + deviceImpDto.vendorSn.length + "]"
                                    };
                                }
                            }
                        }
                    }
                    if (Utils.isNoB(deviceImpDto.assetType)) {
                        deviceImpDto.validateInfo.assetType = {
                            validateOk: false,
                            errorMsg: "[管理方式]单元不可为空"
                        };
                    }
                    // 检查 [数量]
                    if (!Utils.isNaturalStr(deviceImpDto.quantity, true)) {
                        deviceImpDto.validateInfo.quantity = {
                            validateOk: false,
                            errorMsg: "[数量]单元不能为空并且必须为大于0的整数"
                        };
                    }
                    // 检查 [单位]
                    if (!Utils.isNoB(deviceImpDto.theUnit)) {
                        deviceImpDto.theUnit = this.replaceSL(deviceImpDto.theUnit, '');
                        if (deviceImpDto.theUnit.length > 5) {
                            deviceImpDto.validateInfo.theUnit = {
                                validateOk: false,
                                errorMsg: "[单位]单元长度最大5，当前[" + deviceImpDto.theUnit.length + "]"
                            };
                        }
                    }
                    // 检查责任部门 检查责任人
                    if (Utils.isNoB(deviceImpDto.departName) && Utils.isNoB(deviceImpDto.departNo)) {
                        if (!Utils.isNoB(deviceImpDto.principalName)) {
                            deviceImpDto.validateInfo.departName = {
                                validateOk: false,
                                errorMsg: "请先设置[责任部门]"
                            };
                            deviceImpDto.validateInfo.principalName = {
                                validateOk: false,
                                errorMsg: "请先设置[责任部门]"
                            };
                        }
                    } else {
                        if (deviceImpDto.departId == null) {
                            deviceImpDto.validateInfo.departName = {
                                validateOk: false,
                                errorMsg: "[责任部门]单元对应的部门在本机构未找到"
                            };
                            deviceImpDto.validateInfo.principalName = {
                                validateOk: false,
                                errorMsg: "[责任部门]单元对应的部门在本机构未找到"
                            };
                        } else {
                            if ((!Utils.isNoB(deviceImpDto.principalName) || !Utils.isNoB(deviceImpDto.principalNo)) && deviceImpDto.principalId == null) {
                                deviceImpDto.validateInfo.principalName = {
                                    validateOk: false,
                                    errorMsg: "[责任人]异常,请手动设置"
                                };
                            }
                        }
                    }
                    // 检查修正 [备注]
                    if (!Utils.isNoB(deviceImpDto.memo)) {
                        if (deviceImpDto.memo.length > 60) {
                            deviceImpDto.validateInfo.memo = {
                                validateOk: false,
                                errorMsg: "[备注]单元长度最大60，当前[" + deviceImpDto.memo.length + "]"
                            };
                        }
                    }
                    // 特种设备
                    if (deviceImpDto.durable) {
                        deviceImpDto.specialFlag = false;
                    }
                }
                //记录被选中的行
                let oldSelectedRowNos = this.multipleSelection.pluck('rowNo');
                //
                this.deviceImpDto.deviceImpInfoList = rows;
                this.setPageDeviceImpInfoList();
                //（必须）延迟恢复被选中的行
                setTimeout(function () {
                    self.deviceImpDto.deviceImpInfoList.forEach(function (row) {
                        if (oldSelectedRowNos.indexOf(row.rowNo) != -1) {
                            self.$refs.deviceImpInfoTable.toggleRowSelection(row);
                        }
                    });
                }, 1000);
            },
            setPageDeviceImpInfoList: function () {
                let totalRows = this.deviceImpDto.deviceImpInfoList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                let rows = totalRows.slice(start, end);
                this.pageDeviceImpInfoList = rows;
                this.totalCount = totalRows.length;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageDeviceImpInfoList();
            },
            getDlgResult: function () {
                let self = this;
                // 虚拟品牌校验
                let virtualBrandStr = this.virtualBrandStr;
                let virtualBrand = [];
                if (!Utils.isNoB(virtualBrandStr)) {
                    virtualBrand = virtualBrandStr.split('|');
                }
                if (!Utils.isNoB(this.deviceImpDto.warehouseId)) {
                    self.warehouseList.forEach(function (ware) {
                        if (self.deviceImpDto.warehouseId == ware.id) {
                            self.deviceImpDto.warehouseName = ware.name;
                        }
                    });
                }
                this.deviceImpDto.dumyBrandNames = virtualBrand;
                // @date 2019-02-22 16:12 @author libin @desc 增加虚拟导入字段信息
                this.deviceImpDto.virtualFlag = false;
                return this.deviceImpDto;
            },
            dlgSetDeviceImpDto: function (deviceImpDto) {
                let deviceImpInfoList = deviceImpDto.deviceImpInfoList;
                deviceImpInfoList.forEach(function (el) {
                    el.validateInfo = {
                        devcName: {validateOk: true},
                        shopName: {validateOk: true},
                        bizUnitName: {validateOk: true},
                        brandName: {validateOk: true},
                        model: {validateOk: true},
                        fixedSpec: {validateOk: true},
                        quantity: {validateOk: true},
                        buyDate: {validateOk: true},
                        recvDate: {validateOk: true}
                    };
                });
                this.deviceImpDto = deviceImpDto;
                let self = this;
                setTimeout(
                    function () {
                        self.checkData();
                    }, 1000
                );
            },
            // 资产分类
            setDevcCat(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let params = {
                                    checkBox: false,
                                    filter: {
                                        relSysFlag: true,
                                        disabled: false,
                                        level: 3
                                    }
                                };
                                showDevcCatSelectDlg(params, function (devcCat, theDlg) {
                                    theDlg.close();
                                    devcCat = devcCat || {};
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        let tmpRow = self.multipleSelection[i];
                                        let model = self.deviceImpDto.deviceImpInfoList.find(function (row) {
                                            return row.rowNo == tmpRow.rowNo;
                                        });
                                        model.innerDevcCatId = devcCat.id;
                                        model.innerDevcCatCode = devcCat.code;
                                        model.innerDevcCatName = devcCat.name;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置')
                ])
            },
            // 资产品牌
            setDevcBrand(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                //
                                showDevcBrandSelectDlg({
                                    checkBox: false,
                                    filter: {
                                        relSysFlag: true,
                                        disabled: false
                                    }
                                }, function (devcBrand, theDlg) {
                                    theDlg.close();
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        let tmpRow = self.multipleSelection[i];
                                        let model = self.deviceImpDto.deviceImpInfoList.find(function (row) {
                                            return row.rowNo == tmpRow.rowNo;
                                        });
                                        model.innerDevcBrandId = devcBrand.id;
                                        model.innerDevcBrandCode = devcBrand.code;
                                        model.innerDevcBrandName = devcBrand.name;
                                        if (!Utils.isNoB(devcBrand.sysBrandId) && devcBrand.sysBrandId != -1) {
                                            model.brandName = devcBrand.sysBrandName;
                                            model.brandId = devcBrand.sysBrandId;
                                        }
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            setInitStartDate(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("initStartDate");
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的启用日期?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for (var i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].initStartDate = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setfiscalInTime(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("fiscalInTime");
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的入账日期?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].fiscalInTime = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setLastDeprMonth(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("lastDeprMonth", "yyyyMM");
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的最后计提月份?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].lastDeprMonth = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setBuyDate(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("buyDate");
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的购买日期?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].buyDate = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setRecvDate(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("recvDate");
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的收货日期?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].recvDate = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setOnsetDate(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("onsetDate");
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的折旧起算日期?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].onsetDate = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setDate(type, formatType) {
                let self = this;
                if (self.multipleSelection.length == 0) {
                    self.$message.warning("请勾选要设置的行");
                    return;
                }
                let theDlg = Vue.$showDialog({
                    title: '选择日期',
                    width: 300,
                    height: 200,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-shop-device-imp-set-date :formatType="formatType" ref="swb_shop_device_imp_set_date"></swb-shop-device-imp-set-date>' +
                    '</div>',
                    data: {
                        formatType: formatType
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_shop_device_imp_set_date.getDlgResult() || {};
                        if (result.type == "info") {
                            let selectDate = result.data;
                            for (let i = 0; i < self.multipleSelection.length; i++) {
                                self.multipleSelection[i][type] = selectDate;
                            }
                            self.checkData();
                            return true;
                        } else {
                            self.$message.warning(result.message);
                        }
                        return false;
                    },
                    methods: {}
                });
            },
            setBrand(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let catId = null;
                                for (var i = 0; i < self.multipleSelection.length; i++) {
                                    var obj = self.multipleSelection[i];
//                                    if(obj.devcDefId != null) {
//                                        MsgBox.warning("关联定义的设备不可修改分类、品牌、规格等信息");
//                                        return;
//                                    }
                                    if (obj.catId == null) {
                                        MsgBox.warning("请选择已设置分类的行");
                                        return;
                                    }
                                    if (catId == null) {
                                        catId = obj.catId;
                                    } else if (catId != obj.catId) {
                                        MsgBox.warning("请选择相同分类的行");
                                        return;
                                    }
                                }
                                let params = {
                                    selectIds: [],
                                    catId: catId
                                };
                                openBrandListSelectDlg(false, params, function (brand) {
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].brandName = brand.dispName;
                                        self.multipleSelection[i].brandId = brand.id;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            // 设置维保分组
            setDevcGroup(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let params = {
                                    filter: {
                                        level: 2
                                    },
                                    checkBox: false
                                };
                                showDevcGroupSelectDlg(params, function (devcGroup, theDlg) {
                                    theDlg.close();
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        let tmpRow = self.multipleSelection[i];
                                        tmpRow.devcGroupId = devcGroup.id;
                                        tmpRow.devcGroupId1 = devcGroup.parentId;
                                        tmpRow.devcGroupId2 = devcGroup.id;
                                        tmpRow.devcGroupName = devcGroup.name;
                                        tmpRow.devcGroupFullName = devcGroup.fullName;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            setDepart(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                //
                                let bizUnitIds = [];
                                for (let i = 0; i < self.multipleSelection.length; i++) {
                                    let selectRow = self.multipleSelection[i];
                                    if (!bizUnitIds.contains(selectRow.bizUnitId)) {
                                        bizUnitIds.push(selectRow.bizUnitId);
                                    }
                                }
                                if (bizUnitIds.length > 1) {
                                    MsgBox.warning("批量设置责任部门的时候，选择的资产必须是同一个业务单元的资产！");
                                    return;
                                }
                                //
                                Vue.$showDialog({
                                    title: '责任部门 - 选择',
                                    width: 750,
                                    height: 600,
                                    showCloseBtn: true,
                                    template: '<swb-org-tree  :bizUnitId="bizUnitId" :comFlag="true" :isRadio="true" :bizDepart="true"  ref="swb_org_tree"></swb-org-tree>',
                                    data: {
                                        bizUnitId: bizUnitIds[0]
                                    },
                                    okClicked: function () {
                                        let result = this.$refs.swb_org_tree.getDlgResult() || {};
                                        if (result.type == "info") {
                                            let selectComInfo = result.data;
                                            for (let i = 0; i < self.multipleSelection.length; i++) {
                                                self.multipleSelection[i].departId = selectComInfo.id;
                                                self.multipleSelection[i].departName = selectComInfo.name;
                                                self.multipleSelection[i].departNo = selectComInfo.no;
                                            }
                                            self.checkData();
                                        } else {
                                            return false;
                                        }
                                    }
                                });
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的责任部门?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].departId = null;
                                        self.multipleSelection[i].departName = null;
                                        self.multipleSelection[i].departNo = null;
                                        self.multipleSelection[i].principalId = null;
                                        self.multipleSelection[i].principalName = null;
                                        self.multipleSelection[i].principalNo = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setBathPrincipal(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let departIds = self.multipleSelection.pluck("departId");
                                let departIdList = [];
                                departIds.forEach(function (departId) {
                                    if (!departIdList.contains(departId)) {
                                        departIdList.push(departId);
                                    }
                                });
                                if (departIdList.length > 1) {
                                    MsgBox.warning("请选择相同的责任部门进行批量设置责任人");
                                    return;
                                }
                                let departId = departIdList[0];
                                if (Utils.isNoB(departId)) {
                                    MsgBox.warning("必须选择已设置责任部门的行进行设置责任人");
                                    return;
                                }
                                openComStaffComnSelectDlg(departId, false, function (resultData, theDlg) {
                                    theDlg.close();
                                    let departStaff = resultData.data || {};
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].principalId = departStaff.id;
                                        self.multipleSelection[i].principalName = departStaff.name;
                                        self.multipleSelection[i].principalNo = departStaff.no;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的责任人?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].principalId = null;
                                        self.multipleSelection[i].principalName = null;
                                        self.multipleSelection[i].principalNo = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setPrincipal(row) {
                let self = this;
                if (Utils.isNoB(row.departId)) {
                    MsgBox.warning("请先设置责任部门");
                } else {
                    openComStaffComnSelectDlg(row.departId, false, function (resultData, theDlg) {
                        theDlg.close();
                        let departStaff = resultData.data || {};
                        for (let i = 0; i < self.multipleSelection.length; i++) {
                            self.multipleSelection[i].principalId = departStaff.staffId;
                            self.multipleSelection[i].principalName = departStaff.name;
                            self.multipleSelection[i].principalNo = departStaff.staff.no;
                        }
                        self.checkData();
                    });
                }
            },
            delPrincipal(row) {
                row.principalId = null;
                row.principalName = null;
                row.principalNo = null;
                this.checkData();
            },
            autoSetBatchNo(h)  {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                let rows = self.deviceImpDto.deviceImpInfoList.clone();
                                for (let i = 0; i < rows.length; i++) {
                                    let deviceImpDto = rows[i];
                                    if (Utils.isNoB(deviceImpDto.batchNo)) {
                                        let batchNoDate = new Date();
                                        if (!Utils.isNoB(deviceImpDto.buyDate)) {
                                            batchNoDate = deviceImpDto.buyDate;
                                        } else if (!Utils.isNoB(deviceImpDto.recvDate)) {
                                            batchNoDate = deviceImpDto.recvDate;
                                        }
                                        //
                                        deviceImpDto.batchNo = new Date(batchNoDate).format('yyyyMMdd');
                                    }
                                }
                                self.checkData();
                            }
                        }
                    }, '自动生成批次号'),
                ])
            },
            setClassifyTag(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                //
                                let durableCount = 0;
                                let singleCount = 0;
                                for (let i = 0; i < self.multipleSelection.length; i++) {
                                    let item = self.multipleSelection[i];
                                    if (Utils.isTrue(item.durable)) {
                                        durableCount += 1;
                                    } else {
                                        singleCount += 1;
                                    }
                                }
                                if (durableCount > 0) {
                                    self.$message.warning("勾选的行必须都是单品的");
                                    return;
                                }
                                showDevcClassifyTagListSelectDlg(function (tag) {
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].classifyTagId = tag.id;
                                        self.multipleSelection[i].classifyTagName = tag.name;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '选择'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                for (let i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i].classifyTagId = null;
                                    self.multipleSelection[i].classifyTagName = null;
                                }
                                self.checkData();
                            }
                        }
                    }, '清除')
                ])
            },
            setCustField(h, field){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("custFiled", "yyyy-MM-dd", field);
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                for (let i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i]['custFiled'][field] = null;
                                }
                                self.checkData();
                            }
                        }
                    }, '清除')
                ])
            },
            getShopDeviceList()  {
                alert(1);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            coverByDevcDefChange(){
                if (this.deviceImpDto.coverByDevcDef) {
                    this.validateDeviceImpModel(true);
                }
            },
            // 逐条检查
            validateDeviceImpModel: function (isFirst) {
                this.checkNextIndex = isFirst ? 0 : this.checkNextIndex;
                this.startFlag = true;
                let self = this;
                this.getDlgResult();
                let deviceImpDto = this.deviceImpDto;
                //
                let srcDeviceImpInfoList = deviceImpDto.deviceImpInfoList;
                let srcListLength = srcDeviceImpInfoList.length;
                console.log(srcListLength);
                //
                let checkNextIndex = this.checkNextIndex;
                let srcImpInfo = srcDeviceImpInfoList[checkNextIndex];
                let postData = Utils.merge({}, deviceImpDto);
                postData.deviceImpInfoList = [srcImpInfo];
                //
                let srcBizFlag = self.fileObj.srcBizFlag;    // 需维修，需安装，需检验等状态更新导入
                if (!Utils.isNoB(srcBizFlag) && srcBizFlag == 'devc.asset.biz.state.impl') {
                    self.checkAssetBizStateFunc(postData);
                } else {
                    let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                    devcApi.validateDeviceFiscalInImpModel(postData, function (result) {
                        theLoading.hide();
                        let callItem = result.data.deviceImpInfoList[0];
                        if (result.type == 'info') {
                            callItem.failed = false;
                            callItem.failDesc = null;
                        } else {
                            callItem.failed = true;
                            callItem.failDesc = result.message;
                        }
                        srcDeviceImpInfoList[checkNextIndex] = Utils.merge({}, callItem);
                        deviceImpDto.deviceImpInfoList = srcDeviceImpInfoList;
                        self.deviceImpDto = Utils.merge({}, deviceImpDto);
                        self.checkData();
                        //
                        let pageSize = self.pageSize;
                        let pageNumber = (checkNextIndex + 1) / pageSize;
                        let pageNumber2 = (checkNextIndex + 1) % pageSize;
                        if (pageNumber2 != 0) {
                            pageNumber = pageNumber + 1;
                        }
                        self.handlePageChange(pageNumber);
                        // self.pageDeviceImpInfoList = Utils.merge([], srcDeviceImpInfoList);
                        //
                        if (checkNextIndex < srcListLength - 1) {
                            self.checkNextIndex += 1;
                            self.validateDeviceImpModel(false);
                        } else {
                            self.handlePageChange(1);
                        }
                    });
                }
            },
            // 逐条检查导入
            doDeviceImpModelImport() {
                let self = this;
                this.getDlgResult();
                let deviceImpDto = this.deviceImpDto;
                deviceImpDto.retailerShopId = this.fileObj.extra.retailerShopId;
                deviceImpDto.retailerBizUnitId = this.fileObj.extra.retailerBizUnitId;
                //
                let srcBizFlag = self.fileObj.srcBizFlag;    // 需维修，需安装，需检验等状态更新导入
                if (!Utils.isNoB(srcBizFlag) && srcBizFlag == 'devc.asset.biz.state.impl') {
                    self.importAssetBizStatefunc(deviceImpDto);
                } else {
                    let theLoading = MsgBox.loading("正在执行导入");
                    devcApi.doDeviceFiscalInImpModelImport(deviceImpDto, function (result) {
                        theLoading.close();
                        if (result.type == 'info') {
                            if (result.data) {
                                self.$emit('other-close', result.data);
                            } else {
                                MsgBox.warning('请检查通过再导入');
                            }
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            replaceSL(str, char) {
                if (!Utils.isNoB(str)) {
                    str = Utils.replace(str, '\r\n', char);
                    str = Utils.replace(str, '\r', char);
                    str = Utils.replace(str, '\n', char);
                }
                return str;
            },
            setBathDevcDef(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                //
                                let durableCount = 0;
                                let singleCount = 0;
                                for (let i = 0; i < self.multipleSelection.length; i++) {
                                    let item = self.multipleSelection[i];
                                    if (Utils.isTrue(item.durable)) {
                                        durableCount += 1;
                                    } else {
                                        singleCount += 1;
                                    }
                                }
                                if (durableCount > 0 && singleCount > 0) {
                                    self.$message.warning("勾选的行必须都是批量的或者都是单品的");
                                    return;
                                }
                                let params = {};
                                if (durableCount > 0) {
                                    params.assetType = 1;
                                } else {
                                    params.assetType = 0;
                                }
                                showMerchtDevcDefSelectDlg(params, function (devcDef, dlg) {
                                    dlg.close();
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].devcDefId = devcDef.id;
                                        self.multipleSelection[i].devcDefCode = devcDef.innerCode;
                                        self.multipleSelection[i].srcData = Utils.merge({}, self.multipleSelection[i]);
                                        self.multipleSelection[i].brandId = devcDef.brandId;
                                        self.multipleSelection[i].brandName = devcDef.brandName;
                                        self.multipleSelection[i].name = devcDef.name;
                                        self.multipleSelection[i].theUnit = devcDef.theUnit;
                                        self.multipleSelection[i].model = devcDef.model;
                                        self.multipleSelection[i].fixedSpec = devcDef.fixedSpec;
                                        self.multipleSelection[i].fixedSpecCode = devcDef.innerCode;
                                        //
                                        if (self.deviceImpDto.coverByDevcDef) {
                                            self.multipleSelection[i].title = devcDef.title;
                                            self.multipleSelection[i].innerDevcCatId = devcDef.innerDevcCatId;
                                            self.multipleSelection[i].innerDevcCatCode = devcDef.innerDevcCode;
                                            self.multipleSelection[i].innerDevcCatName = devcDef.innerDevcCatName;
                                            self.multipleSelection[i].innerDevcBrandId = devcDef.innerDevcBrandId;
                                            self.multipleSelection[i].innerDevcBrandCode = devcDef.innerDevcBrandCode;
                                            self.multipleSelection[i].innerDevcBrandName = devcDef.innerDevcBrandName;
                                            self.multipleSelection[i].assetKindCode = devcDef.assetKindCode;
                                            self.multipleSelection[i].assetKindName = devcDef.assetKindName;
                                            self.multipleSelection[i].expectedLife = devcDef.durableLife;
                                            self.multipleSelection[i].deprSpecCode = devcDef.deprSpecCode;
                                            self.multipleSelection[i].asmblFlag = devcDef.asmblFlag;
                                            self.multipleSelection[i].setupFlag = devcDef.setupFlag;
                                            self.multipleSelection[i].devcGroupId = devcDef.devcGroupId;
                                            self.multipleSelection[i].devcGroupFullName = devcDef.devcGroupFullName;
                                            self.multipleSelection[i].splitible = devcDef.splitible;
                                            self.multipleSelection[i].useManner = devcDef.useManner;
                                            self.multipleSelection[i].useMannerText = self.devcUseMannerMap[devcDef.useManner];
                                        } else {
                                            if (Utils.isNoB(self.multipleSelection[i].title)) {
                                                self.multipleSelection[i].title = devcDef.title;
                                            }
                                            if (Utils.isNoB(self.multipleSelection[i].innerDevcCatCode) && Utils.isNoB(self.multipleSelection[i].innerDevcCatName)) {
                                                self.multipleSelection[i].innerDevcCatId = devcDef.innerDevcCatId;
                                                self.multipleSelection[i].innerDevcCatCode = devcDef.innerDevcCode;
                                                self.multipleSelection[i].innerDevcCatName = devcDef.innerDevcCatName;
                                            }
                                            if (Utils.isNoB(self.multipleSelection[i].innerDevcBrandCode) && Utils.isNoB(self.multipleSelection[i].innerDevcBrandName)) {
                                                self.multipleSelection[i].innerDevcBrandId = devcDef.innerDevcBrandId;
                                                self.multipleSelection[i].innerDevcBrandCode = devcDef.innerDevcBrandCode;
                                                self.multipleSelection[i].innerDevcBrandName = devcDef.innerDevcBrandName;
                                            }
                                            if (Utils.isNoB(self.multipleSelection[i].assetKindCode)) {
                                                self.multipleSelection[i].assetKindCode = devcDef.assetKindCode;
                                                self.multipleSelection[i].assetKindName = devcDef.assetKindName;
                                            }
                                            if (Utils.isNoB(self.multipleSelection[i].expectedLife)) {
                                                self.multipleSelection[i].expectedLife = devcDef.durableLife;
                                            }
                                        }
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '选择'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的关联定义吗?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        if (self.multipleSelection[i].devcDefId != null && self.multipleSelection[i].devcDefId != -1) {
                                            self.multipleSelection[i].devcDefId = null;
                                            self.multipleSelection[i].devcDefCode = null;
                                            if (!Utils.isNoB(self.multipleSelection[i].srcData)) {
                                                self.multipleSelection[i].brandId = self.multipleSelection[i].srcData.brandId;
                                                self.multipleSelection[i].brandName = self.multipleSelection[i].srcData.brandName;
                                                self.multipleSelection[i].devcName = self.multipleSelection[i].srcData.devcName;
                                                self.multipleSelection[i].title = self.multipleSelection[i].srcData.title;
                                                self.multipleSelection[i].theUnit = self.multipleSelection[i].srcData.theUnit;
                                                self.multipleSelection[i].model = self.multipleSelection[i].srcData.model;
                                                self.multipleSelection[i].fixedSpec = self.multipleSelection[i].srcData.fixedSpec;
                                                self.multipleSelection[i].fixedSpecCode = self.multipleSelection[i].srcData.fixedSpecCode;
                                                self.multipleSelection[i].expectedLife = self.multipleSelection[i].srcData.expectedLife;
                                                self.multipleSelection[i].innerDevcCatId = self.multipleSelection[i].srcData.innerDevcCatId;
                                                self.multipleSelection[i].innerDevcCatCode = self.multipleSelection[i].srcData.innerDevcCatCode;
                                                self.multipleSelection[i].innerDevcCatName = self.multipleSelection[i].srcData.innerDevcCatName;
                                                self.multipleSelection[i].innerDevcBrandId = self.multipleSelection[i].srcData.innerDevcBrandId;
                                                self.multipleSelection[i].innerDevcBrandCode = self.multipleSelection[i].srcData.innerDevcBrandCode;
                                                self.multipleSelection[i].innerDevcBrandName = self.multipleSelection[i].srcData.innerDevcBrandName;
                                                self.multipleSelection[i].assetKindCode = self.multipleSelection[i].srcData.assetKindCode;
                                                self.multipleSelection[i].assetKindName = self.multipleSelection[i].srcData.assetKindName;
                                                self.multipleSelection[i].srcData = null;
                                            }
                                        }
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setDevcDef(row) {
                let self = this;
                let assetType = null;
                if (Utils.isTrue(row.assetType == '批量式管理')) {
                    assetType = 1;
                } else {
                    assetType = 0;
                }
                let modelSpec = row.model + '' + row.fixedSpec;
                showMerchtDevcDefSelectDlg({
                    catId: row.catId,
                    brandId: row.brandId,
                    modelSpec: modelSpec,
                    assetType: assetType
                }, function (devcDef, dlg) {
                    dlg.close();
                    row.devcDefId = devcDef.id;
                    row.devcDefCode = devcDef.innerCode;
                    row.srcData = Utils.merge({}, row);
                    row.brandId = devcDef.brandId;
                    row.brandName = devcDef.brandName;
                    row.name = devcDef.name;
                    row.theUnit = devcDef.theUnit;
                    row.model = devcDef.model;
                    row.fixedSpec = devcDef.fixedSpec;
                    row.fixedSpecCode = devcDef.innerCode;
                    if (self.deviceImpDto.coverByDevcDef) {
                        row.title = devcDef.title;
                        row.innerDevcCatId = devcDef.innerDevcCatId;
                        row.innerDevcCatCode = devcDef.innerDevcCode;
                        row.innerDevcCatName = devcDef.innerDevcCatName;
                        row.innerDevcBrandId = devcDef.innerDevcBrandId;
                        row.innerDevcBrandCode = devcDef.innerDevcBrandCode;
                        row.innerDevcBrandName = devcDef.innerDevcBrandName;
                        row.assetKindCode = devcDef.assetKindCode;
                        row.assetKindName = devcDef.assetKindName;
                        row.expectedLife = devcDef.durableLife;
                        row.deprSpecCode = devcDef.deprSpecCode;
                        row.asmblFlag = devcDef.asmblFlag;
                        row.setupFlag = devcDef.setupFlag;
                        row.devcGroupId = devcDef.devcGroupId;
                        row.devcGroupFullName = devcDef.devcGroupFullName;
                        row.splitible = devcDef.splitible;
                        row.useManner = devcDef.useManner;
                        row.useMannerText = self.devcUseMannerMap[devcDef.useManner];
                    } else {
                        if (Utils.isNoB(row.title)) {
                            row.title = devcDef.title;
                        }
                        if (Utils.isNoB(row.innerDevcCatCode) && Utils.isNoB(row.innerDevcCatName)) {
                            row.innerDevcCatId = devcDef.innerDevcCatId;
                            row.innerDevcCatCode = devcDef.innerDevcCode;
                            row.innerDevcCatName = devcDef.innerDevcCatName;
                        }
                        if (Utils.isNoB(row.innerDevcBrandCode) && Utils.isNoB(row.innerDevcBrandName)) {
                            row.innerDevcBrandId = devcDef.innerDevcBrandId;
                            row.innerDevcBrandCode = devcDef.innerDevcBrandCode;
                            row.innerDevcBrandName = devcDef.innerDevcBrandName;
                        }
                        if (Utils.isNoB(row.assetKindCode)) {
                            row.assetKindCode = devcDef.assetKindCode;
                            row.assetKindName = devcDef.assetKindName;
                        }
                        if (Utils.isNoB(row.expectedLife)) {
                            row.expectedLife = devcDef.durableLife;
                        }
                    }
                    self.checkData();
                });
            },
            delDevcDef(row) {
                if (row.devcDefId != null) {
                    row.devcDefId = null;
                    row.devcDefCode = null;
                    if (Utils.isNoB(row.srcData)) {
                        row.brandId = row.srcData.brandId;
                        row.brandName = row.srcData.brandName;
                        row.name = row.srcData.name;
                        row.title = row.srcData.title;
                        row.theUnit = row.srcData.theUnit;
                        row.model = row.srcData.model;
                        row.fixedSpec = row.srcData.fixedSpec;
                        row.fixedSpecCode = row.srcData.fixedSpecCode;
                        row.expectedLife = row.srcData.expectedLife;
                        row.innerDevcCatId = row.srcData.innerDevcCatId;
                        row.innerDevcCatCode = row.srcData.innerDevcCatCode;
                        row.innerDevcCatName = row.srcData.innerDevcCatName;
                        row.innerDevcBrandId = row.srcData.innerDevcBrandId;
                        row.innerDevcBrandCode = row.srcData.innerDevcBrandCode;
                        row.innerDevcBrandName = row.srcData.innerDevcBrandName;
                        row.assetKindCode = row.srcData.assetKindCode;
                        row.assetKindName = row.srcData.assetKindName;
                        row.srcData = null;
                    }
                }
                this.checkData();
            },
            showDevcDef(id){
                openDevcDefDetailDlg(id);
            },
            // ================================================ 资产状态检查导入 ================================================
            importAssetBizStatefunc: function (deviceImpDto) {
                let theLoading = MsgBox.loading("正在执行导入");
                devcApi.doAssetBizStateImpModelImport(deviceImpDto, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        if (result.data) {
                            self.$emit('other-close', result.data);
                        } else {
                            MsgBox.warning('请检查通过再导入');
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkAssetBizStateFunc: function (postData) {
                let self = this;
                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                devcApi.validateAssetBizStateImpModel(postData, function (result) {
                    theLoading.hide();
                    let callItem = result.data.deviceImpInfoList[0];
                    if (result.type == 'info') {
                        callItem.failed = false;
                        callItem.failDesc = null;
                    } else {
                        callItem.failed = true;
                        callItem.failDesc = result.message;
                    }
                    srcDeviceImpInfoList[checkNextIndex] = Utils.merge({}, callItem);
                    deviceImpDto.deviceImpInfoList = srcDeviceImpInfoList;
                    self.deviceImpDto = Utils.merge({}, deviceImpDto);
                    self.checkData();
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (checkNextIndex + 1) / pageSize;
                    let pageNumber2 = (checkNextIndex + 1) % pageSize;
                    if (pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    self.handlePageChange(pageNumber);
                    if (checkNextIndex < srcListLength - 1) {
                        self.checkNextIndex += 1;
                        self.validateDeviceImpModel(false);
                    } else {
                        self.handlePageChange(1);
                    }
                });
            }
        }
    }
</script>

<style>
    .el-table .selected-row {
        background: #c9e5f5;
    }
</style>



// WEBPACK FOOTER //
// src/compo/retailer/AssetFiscalInImpCheck.vue